import { ChangeSurveyPageAction, NavBarStateAction, changePageAction, changePageWithDetailThunkAction, initNavBarAction } from "./action";
import { NavBarInfo } from "./state";
import { Dispatch } from "redux";

export function initTopNavBarThunk(navList:NavBarInfo[]){
    return (dispatch: Dispatch<NavBarStateAction>)=>{
      dispatch(initNavBarAction(navList));  
  }
}


export function changePageThunk(page:number,index:number){
    return (dispatch: Dispatch<NavBarStateAction>)=>{
      dispatch(changePageAction(page,index));  
  }
}

export function ChangeSurveyChangeThunk(surveyPage:number){
  return (dispatch: Dispatch<NavBarStateAction>)=>{
    dispatch(ChangeSurveyPageAction(surveyPage));  
}
}

export function changePageWithDetailThunk(page:number,index:number,nav_bar_detail:string){
    return (dispatch: Dispatch<NavBarStateAction>)=>{
    dispatch(changePageWithDetailThunkAction(page,index,nav_bar_detail));  
}
}